export const getDiscountedPriceCentAmount = (
  centAmount: number,
  discount: number,
) => centAmount - (centAmount * discount) / 100
